export default {
  keepControl: {
    title: {
      fr: "Gardez le contrôle,\nMême après résiliation.",
      en: "Stay in control,\nEven after cancellation.",
    },
    description: {
      description1: {
        fr: "En cas d’arrêt de l’abonnement à la plateforme d’hypervision multisite, garder le contrôle total de votre installation grâce à <strong>notre application mobile gratuite.</strong>",
        en: "If you stop your subscription to the multi-site hypervision platform, you still retain full control of your installation with <strong>our free mobile application.</strong>",
      },
      description2: {
        fr: "<strong>Tout continuera de fonctionner site par site et maintenu à jour sans frais.</strong> Une solution pensée pour vous offrir autonomie et continuité de service selon vos besoins.",
        en: "<strong>Everything continues to run site by site and remains updated at no additional cost.</strong> A solution designed to provide autonomy and service continuity according to your needs.",
      },
    },
  },
};
